import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import moment from 'moment';

import { fetchTemplates } from '../../../../actions/ChecklistActions';
import { editChecklist } from '../../../../actions/ChecklistV2Actions';
import { hideModal } from '../../../../actions/ModalActions';
import { getUserWeddingDate, getUserWeddingMonthYearDate } from '../../../../selectors/user/userSelectors';

import ChecklistEditSettings from './ChecklistEditSettings';

const selector = formValueSelector('EditChecklistFormV2');

const mapStateToProps = (state) => {
  const weddingDate = getUserWeddingDate(state) || getUserWeddingMonthYearDate(state);
  const formattedWeddingDate = weddingDate && moment.utc(weddingDate).format('MM/DD/YYYY');

  return {
    initialValues: {
      detailed: state.checklist.checklist.isDetailed ? 'true' : 'false',
      checklist_template_ids: state.checklist.checklist.templateIds,
      wedding_date: formattedWeddingDate,
      registryIsPublic: state.registry.public,
    },
    templates: state.checklist.templates,
    selectedTemplateIds: selector(state, 'checklist_template_ids') || [],
  };
};

const mapDispatchToProps = dispatch => ({
  getTemplates: () => dispatch(fetchTemplates()),
  onSubmit: (editChecklistRequest) => {
    dispatch(editChecklist(editChecklistRequest));
    dispatch(hideModal());
  },
  onUpdateTemplateIds: input => dispatch(input),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  reduxForm({
    form: 'EditChecklistFormV2',
    enableReinitialize: true,
  })(ChecklistEditSettings),
);



// WEBPACK FOOTER //
// ./src/components/manage/ChecklistV2/ChecklistEditSettings/index.js